<div class="editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device" [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config   [device]="device"   [elementChoosing]="objectChoosing" [width]="class['text-discount']['width']" [height]="class['text-discount']['height']"
        (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline">
      <!-- CẤU HÌNH GIÁ CHIẾT KHẤU -->
      <li nz-submenu nzTitle="{{ 'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <div class="editor-field-body">
            <div class="field-row">
              <!-- Nhập nội dung -->
              <div class="config-name" style="flex-wrap:wrap">
                <p class="m-0">{{ 'noi_dung' | translate}}</p>
                <textarea matInput placeholder="{{'nhap_noi_dung' | translate}}"
                  [ngModel]="staticdata['discount_content_' + functionService.selectedLanguageCode] | vhLanguage : '' : objectChoosing.component"
                  (ngModelChange)="staticdata['discount_content_' + functionService.selectedLanguageCode] = $event"
                  (blur)="updateStaticData()" style="background-color: white; padding: 8px; margin-top: 4px"></textarea>
              </div>
              <!-- Màu nền -->
              <div class="config-name my-2">
                <p class="m-0" style="width: 50%;">{{ 'mau_nen' | translate}}</p>
                <input class="input-color" id="input-bgColor" style="width: 50% !important"
                  [style.background]="class['text-discount__content']['background-color']" [cpOKButton]="true"
                  [(colorPicker)]="class['text-discount__content']['background-color']" (colorPickerClose)="updateClass()"
                  type="button" />
              </div>
              <!-- Màu nền gradient -->
              <div class="mr-2 mb-4 view-more" style="
                display: flex;
                align-items: center;
                justify-content: flex-end;
                gap: 7px;
              ">
                <p class="discover_text" (click)="openViewAll(styles_field[0])"
                  style="cursor: pointer; text-align: left; margin: 0">
                  {{'Gradient' | translate}} &#8594;
                </p>
              </div>
              <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class" [config]="config"
                [staticdata]="staticdata" [textContentClass]="class['text-discount__content']"
                [textWrapperClass]="class['text-discount__wrapper']" [isHideTextAlign]="true">
              </app-text-format-config>
            </div>
          </div>
        </div>
      </li>
      <!-- Bo tròn-->
      <li nz-submenu nzTitle="{{'bo_goc' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="editor-field">
          <div class="editor-field-body">
            <div class="field-row">
              <div class="text-hidden my-2">
                <span style="line-height: 1.5;">{{ 'hinh_tron' | translate}}</span>
                <nz-switch [(ngModel)]="config['isCircle']" (ngModelChange)="handleToggleBorderRadius()"></nz-switch>
              </div>
              <!-- Bo tròn -->
              <app-borders-radius-config *ngIf="!config['isCircle']" [elementChoosing]="objectChoosing" [device]="device"
                [class]="class" [borderRadiusClass]="class['text-discount__content']" [id_object]="objectChoosing._id">
              </app-borders-radius-config>
            </div>
          </div>
        </div>
      </li>
      <!-- Viền-->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderClass]="class['text-discount__content']" [id_object]="objectChoosing._id">
        </app-borders-config>
      </li>
      <!-- Cấu hình đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['text-discount__content']"
          [shadowConfig]="config['box-shadow']" [objectChoosing]="objectChoosing">
        </app-shadow-config>
      </li>
      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <app-rotate-config [classRotate]="class['text-discount']" [config]="config" [device]="device"
          [objectChoosing]="objectChoosing"></app-rotate-config>
      </li>
      <!-- Cấu hình hình dạng-->
      <li nz-submenu nzTitle="{{'hinh_dang' | translate}}" [(nzOpen)]="openMap.menu10"
        (nzOpenChange)="openHandler('menu10')">
        <div class="field">
          <nz-switch [(ngModel)]="isUsedClipPath" class="my-2 d-flex justify-content-center"
          (ngModelChange)="class['text-discount__content']['clip-path'] = $event ? 'polygon(50% 0%, 0% 100%, 100% 100%)' : 'none'; updateClass()">
          </nz-switch>
          <ng-container *ngIf="class['text-discount__content']['clip-path'] !== 'none'">
            <!-- CHỌN MẪU HÌNH DẠNG -->
            <div class="items">
              <div class="items__type">
                <div class="items__content" *ngFor="let item of clipPaths" (click)="chooseItem(item, $event)"
                [class.active]="class['text-discount__content']['clip-path'] == item.clipPath">
                  <button [ngStyle]="{
                      'background-color': '#ffd400',
                      'clip-path': item.clipPath
                    }">
                  </button>
                </div>
              </div>
            </div>
            <!-- Tuỳ chỉnh cho cấu hình này -->
            <div class="items__type-custom mt-4">
              <p>{{'nhap_gia_tri_polygon_inset_ellipse_tuy_chinh' | translate}}</p>
              <textarea class="input w-100" placeholder="polygon(50% 0%, 0% 100%, 100% 100%)" [(ngModel)]="class['text-discount__content']['clip-path']"
                style="min-height: 100px" (blur)="updateClass()">
              </textarea>
            </div>
          </ng-container>
        </div>
      </li>
      <!-- Khoảng đệm -->
      <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMap.menu11"
        (nzOpenChange)="openHandler('menu11')">
        <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
          [classPadding]="class['text-discount__content']" [paddingConfigs]="[
            { type: 'top' },
            { type: 'bottom' },
            { type: 'left' },
            { type: 'right' }
          ]">
        </app-padding-config>
      </li>
      <!-- Cấu hình nếp gấp -->
      <li nz-submenu nzTitle="{{'nep_gap' | translate}}" [(nzOpen)]="openMap.menu12"
        (nzOpenChange)="openHandler('menu12')">
        <nz-switch [ngModel]="config.discount_fold?.display && config.discount_fold.display != 'none'"
        class="my-2 d-flex justify-content-center"
        (ngModelChange)="config.discount_fold.display = $event ? 'block' : 'none'; updateConfig()">
        </nz-switch>
        <ng-container *ngIf="config.discount_fold?.display && config.discount_fold.display != 'none'">
          <!-- Chọn màu -->
          <div class="config-name">
            <span class="title w-50">{{'mau' | translate}}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true" [cpWidth]="'230px'"
              [(colorPicker)]="config.discount_fold.background_color"
              [style.background]="config.discount_fold.background_color"
              (colorPickerClose)="updateConfig()" />
          </div>
          <!-- Cấu hình chiều dài -->
          <div class="config-name mt-2">
            <span class="title w-50">{{'chieu_dai' | translate}}</span>
            <nz-input-number
              [ngModel]="config.discount_fold.width | vhnumber"
              [nzMin]="0" [nzMax]="100" [nzStep]="1"
              (ngModelChange)="config.discount_fold.width = $event + 'px'"
              (nzBlur)="updateConfig()">
            </nz-input-number>
          </div>
          <!-- Cấu hình chiều cao -->
          <div class="config-name mt-2">
            <span class="title w-50">{{'chieu_cao' | translate}}</span>
            <nz-input-number
              [ngModel]="config.discount_fold.height | vhnumber"
              [nzMin]="0" [nzMax]="100" [nzStep]="1"
              (ngModelChange)="config.discount_fold.height = $event + 'px'"
              (nzBlur)="updateConfig()">
            </nz-input-number>
          </div>
          <!-- Cấu hình vị trí chiều dọc từ dưới lên -->
          <div class="config-name mt-2">
            <span class="title w-50">{{'vi_tri_chieu_doc_tu_duoi_len' | translate}}</span>
            <nz-input-number
              [ngModel]="config.discount_fold.bottom | vhnumber"
              [nzMin]="-100" [nzMax]="100" [nzStep]="1"
              (ngModelChange)="config.discount_fold.bottom = $event + 'px'"
              (nzBlur)="updateConfig()">
            </nz-input-number>
          </div>
          <!-- Cấu hình vị trí chiều ngang từ trái sang -->
          <div class="config-name mt-2">
            <span class="title w-50">{{'vi_tri_chieu_ngang_tu_trai_sang' | translate}}</span>
            <nz-input-number
              [ngModel]="config.discount_fold.left | vhnumber"
              [nzMin]="-100" [nzMax]="100" [nzStep]="1"
              (ngModelChange)="config.discount_fold.bottom = $event + 'px'"
              (nzBlur)="updateConfig()">
            </nz-input-number>
          </div>
          <div class="mt-2">
            <!-- CHỌN MẪU HÌNH DẠNG -->
            <div class="items">
              <div class="items__type">
                <div class="items__content" *ngFor="let item of clipPaths"
                (click)="config.discount_fold.clip_path = item.clipPath; updateConfig()"
                [class.active]="config.discount_fold?.clip_path == item.clipPath">
                  <button [ngStyle]="{
                      'background-color': '#ffd400',
                      'clip-path': item.clipPath
                    }">
                  </button>
                </div>
              </div>
            </div>
            <!-- Tuỳ chỉnh cho cấu hình này -->
            <div class="items__type-custom mt-4">
              <p>{{'nhap_gia_tri_polygon_inset_ellipse_tuy_chinh' | translate}}</p>
              <textarea class="input w-100" placeholder="polygon(50% 0%, 0% 100%, 100% 100%)"
                [(ngModel)]="config.discount_fold.clip_path"
                style="min-height: 100px" (blur)="updateConfig()">
              </textarea>
            </div>
          </div>
        </ng-container>
      </li>
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle=" {{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu0" (nzOpenChange)="openHandler('menu0')">
        <div class="editor-field">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 1">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [(ngModel)]="config['background-color'].gradient_check"
          (ngModelChange)="updateBackgroundRgb()"></label>
      </div>
      <ng-container *ngIf="config['background-color'].gradient_check">
        <div class="list-gradient">
          <button class="btn-gradient" *ngFor="
              let bgGradient of config['background-color']['gradient_arr'];
              let i = index
            " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }"
            [disabled]="!config['background-color'].gradient_check">
            <i class="delete-icon bi bi-x-circle"></i>
          </button>
        </div>
        <p class="title-head">{{'them_mau' | translate}}</p>
        <div class="container_add-gradient">
          <input class="input-color" [cpOKButton]="true" [(colorPicker)]="config['background-color']['background']"
            type="button" [disabled]="!config['background-color'].gradient_check"
            [style.background]="config['background-color']['background']" (colorPickerClose)="addGradient($event)" />
        </div>
        <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
        <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip
          nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event)"
          [disabled]="!config['background-color'].gradient_check"
          [style.background]="type.type + '(' + type.deg + ', #2764EB, #EFE810)'"
          [class.active]="config['background-color'].gradient_direction === type.direction">
        </button>
      </ng-container>
    </div>
  </div>
</div>